
































import { get } from "lodash";
import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ClientInfo } from "@/types";
import EditSummary from "./EditSummary/EditSummary.vue";
import { Message, Breadcrumb } from "@brankas/web-ui";
import { IEditSummaryData } from "./EditSummary/index.dto";
const clientModule = namespace("client");

@Component({
  components: {
    EditSummary,
    Message,
    Breadcrumb,
  },
})
export default class EditTemplate extends Vue {
  @clientModule.State("currentClient") currentClient!: ClientInfo;

  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: Boolean, default: false }) showSummary!: boolean;
  @Prop({ type: String, default: "" }) summaryTitle!: string;
  @Prop({ type: String, default: "" }) summarySubtitle!: string;
  @Prop({ type: Array, default: () => [] }) summaryData!: IEditSummaryData[];
  @Prop({ type: String, default: false }) errorMsg!: string;
  @Prop({ type: Boolean, default: false }) withoutFormWrapper!: boolean;

  get breadcrumbItems() {
    return [
      {
        label: this.currentClient?.name || "",
        link: `/client/${this.$route.params.clientId}`,
      },
      {
        label: this.title,
      },
    ];
  }

  get clientName(): string {
    return get(this.currentClient, "name", "");
  }

  get clientId() {
    return get(this.$route.params, "clientId");
  }

  get navigations() {
    return [
      {
        label: "CLIENT LIST",
        link: "/",
      },
      {
        label: this.clientName || "",
        link: `/client/${this.clientId}`,
      },
      {
        label: this.title,
      },
    ];
  }
}
